import clsx from 'clsx';
import * as React from 'react';
import { CountryData } from '../types';
import { Paragraph, Subheading } from 'components/src/typography';
import { AirplaneTakeOffIcon } from 'components/src/svg';
import { colors } from 'components/src/foundation';
import CheckListItem from './CheckListItem';
import PriceListItem from './PriceListItem';
import { motion } from 'framer-motion';

type Props = {
  countryData: CountryData;
};

const TravellingAbroadData = ({ countryData }: Props) => {
  const showOverview = countryData.travelPackage || countryData['5G'];
  return (
    <motion.div
      initial={{ opacity: 0, x: 50 }}
      animate={{ opacity: 1, x: 0 }}
      exit={{ opacity: 0, x: 50 }}
      className="col-span-full flex flex-col gap-y-32 md:col-span-6 md:col-start-2"
    >
      {countryData.roamingCatagory !== 3 && (
        <div
          className={clsx('flex items-center justify-between rounded-28 p-16', {
            'bg-red-100': countryData.roamingCatagory === 2 || countryData.roamingCatagory === 4,
            'bg-state-success': countryData.roamingCatagory === 1,
          })}
        >
          <Paragraph classes="text-white-100">
            {countryData.roamingCatagory === 1 && 'Reiki í Evrópu gildir'}
            {countryData.roamingCatagory === 2 && 'Reiki í Evrópu gildir ekki'}
            {countryData.roamingCatagory === 4 && 'Sýn er ekki með reikisamning í þessu landi'}
          </Paragraph>
          {countryData.roamingCatagory !== 4 && <AirplaneTakeOffIcon color={colors.white[100]} size={24} />}
        </div>
      )}
      {showOverview && (
        <div>
          <Subheading small bold classes="mb-16 text-black-100">
            {'Yfirlit'}
          </Subheading>
          {countryData.travelPackage && <CheckListItem title="Ferðapakki Sýnar í boði" />}
          {countryData['5G'] && <CheckListItem title="5G í boði" />}
        </div>
      )}
      <div>
        <Subheading small bold classes="mb-16 text-black-100">
          {countryData.roamingCatagory === 3 ? 'Verð utan Ferðapakka' : 'Verðskrá'}
        </Subheading>
        <PriceListItem title="Til Íslands og landa EU (mínútugjald)" price={countryData.minToIceland} />
        <PriceListItem title="Móttekið símtal (mínútugjald)" price={countryData.minAccepted} />
        <PriceListItem title="SMS" price={countryData.SMS} />
        {countryData.mobileInternet && (
          <PriceListItem title="Netið í símann (per MB)" price={countryData.mobileInternet} />
        )}
        {countryData.roamingCatagory === 1 && (
          <PriceListItem title="Umfram gagnamagn (per MB)" price={countryData.roamingEuropeExtraMB} />
        )}
      </div>
    </motion.div>
  );
};

export default TravellingAbroadData;
